import { render, staticRenderFns } from "./ShowSubCategoris.vue?vue&type=template&id=044bbc4b&scoped=true"
import script from "./ShowSubCategoris.vue?vue&type=script&lang=js"
export * from "./ShowSubCategoris.vue?vue&type=script&lang=js"
import style0 from "./ShowSubCategoris.vue?vue&type=style&index=0&id=044bbc4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044bbc4b",
  null
  
)

export default component.exports